export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              📬 投稿爆料
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              有猛料？有大瓜？欢迎随时向我们投稿，一起吃遍全网大瓜
            </p>
          </div>

          <div className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <form
              data-readdy-form=""
              className="flex flex-col gap-4"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="你的昵称"
                  className="px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-700 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="联系邮箱"
                  className="px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-700 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <input
                type="text"
                name="title"
                placeholder="爆料标题"
                className="px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-700 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <textarea
                name="content"
                placeholder="详细描述你的大瓜..."
                rows={4}
                maxLength={500}
                className="px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-700 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
              ></textarea>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />
              <button
                type="submit"
                className="whitespace-nowrap self-start px-8 py-3 rounded-full bg-primary-500 text-background-50 font-label font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-send-plane-line mr-2"></i>
                提交爆料
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}